import { render, staticRenderFns } from "./ChatTextarea.vue?vue&type=template&id=b184a588&scoped=true"
import script from "./ChatTextarea.vue?vue&type=script&lang=js"
export * from "./ChatTextarea.vue?vue&type=script&lang=js"
import style0 from "./ChatTextarea.vue?vue&type=style&index=0&id=b184a588&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b184a588",
  null
  
)

export default component.exports